import { createContext, useContext, useReducer } from 'react'
import { INIT_STATE , reducer} from './reducers/new-patient-reducer'

export const NewPatientContext = createContext({})

export const NewPatientContextProvider = ({ children }) => {
    const [newPatient, newPatientDispatch] = useReducer( reducer, INIT_STATE)
    
    return (
        <NewPatientContext.Provider
            value={{ newPatient, newPatientDispatch}}
        >
            {children}
        </NewPatientContext.Provider>
    )
}

export const useNewPatientContext = ()=> useContext(NewPatientContext)
